import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { CommonModule } from '@angular/common';
import { PlaceRef } from '@app/explore/places.service';
import { AngularSvgIconModule } from 'angular-svg-icon';

@Component({
  selector: 'app-place',
  standalone: true,
  imports: [CommonModule, AngularSvgIconModule],
  templateUrl: './place.component.html',
  styleUrls: ['./place.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PlaceComponent {
  @Input()
  public place!: PlaceRef;

  @Input()
  public query!: string;

  @Input()
  public icon = false;

  public chunk1?: string;
  public chunk2?: string;
  public chunk3?: string;

  ngOnChanges() {
    // remove diacritics from target
    let target = this.display;
    target = target.normalize("NFD").replace(/\p{Diacritic}/gu, "")
    const tLower = target.toLowerCase();
    const pLower = this.query.toLowerCase();
    const startIndex = tLower.indexOf(pLower);
    const endIndex = tLower.indexOf(pLower) + pLower.length;

    if (startIndex !== -1) {
      this.chunk1 = target.slice(0, startIndex);
      this.chunk2 = target.slice(startIndex, endIndex);
      this.chunk3 = target.slice(endIndex, target.length);
    }
  }

  // if this.city is not null, return this.city, this.country
  // else return this.country
  get display() {
    return this.place.city
      ? `${this.place.city}, ${this.place.country}`
      : this.place.state
      ? `${this.place.state}, ${this.place.country}`
      : this.place.country;
  }
}
